import BasePlugin from '@uppy/core/lib/BasePlugin.js'

export class UppyDims extends BasePlugin {
  static VERSION = '0.1'

  constructor (uppy, opts) {
    super(uppy, opts)
    this.id = opts.id || 'UppyDims'
    this.type = 'modifier'
    this.title = 'Image Dimentions - > Meta'

    const defaultOptions = {
      single: null
    }

    this.opts = { ...defaultOptions, ...opts }

  }

  onFileAdded = (file) => {
    const data = file.data // is a Blob instance
    const url = URL.createObjectURL(data)
    const image = new Image()
    image.src = url

    image.onload = () => {

      const minDimensions = this.opts.single.dataset.minDimensions.split(',')
      
      let minDim1 = parseInt(minDimensions[0])
      let minDim2 = parseInt(minDimensions[1])

      let minDim = (minDim1 > minDim2) ? minDim1 : minDim2
      if ( minDim1 == minDim2 && (image.width < minDim1 || image.height < minDim2) ) {
        this.uppy.info(`${this.opts.single.dataset.minDimensionsError} ${minDimensions.join('x')}`, 'error', 3500)
        this.uppy.cancelAll()
        this.uppy.emit('dimensions:all')
        return false
      } else if (minDim1 != minDim2 && image.width < minDim && image.height < minDim ) {
        this.uppy.info(`${this.opts.single.dataset.minDimensionsErrorOneOf} ${minDim}`, 'error', 3500)
        this.uppy.cancelAll()
        this.uppy.emit('dimensions:all')
        return false
      }

      URL.revokeObjectURL(url)
      this.uppy.emit('dimensions:all')
    }

  }

  waitUntilAllProcessed = (fileIDs) => {
    fileIDs.forEach((fileID) => {
      const file = this.uppy.getFile(fileID)
      this.uppy.emit('preprocess-progress', file, {
        mode: 'indeterminate',
        message: 'Processing image dimensions'
      })
    })

    const emitPreprocessCompleteForAll = () => {
      fileIDs.forEach((fileID) => {
        const file = this.uppy.getFile(fileID)
        if (file) {
          this.uppy.emit('preprocess-complete', file)
        }
      })
    }

    return new Promise((resolve, reject) => {

      this.uppy.once('dimensions:all', () => {
        emitPreprocessCompleteForAll()
        resolve()
      })

    })
  }

  install () {
    this.uppy.on('file-added', this.onFileAdded)
    this.uppy.addPreProcessor(this.waitUntilAllProcessed)
  }

  uninstall () {
    this.uppy.off('file-added', this.onFileAdded)
    this.uppy.removePreProcessor(this.waitUntilAllProcessed)
  }
}
